import CollectionView from './base';
import Card from '../views/card';

export default CollectionView.extend( {
	modelView: Card,
} );
